import { getStockDateInfo } from "./getStockDateInfo";
import { getDateFromStatusMessage } from "./getDateFromStatusMessage";

function normalizeToDateString(date: string): string {
  // Handle full ISO datetime (e.g. "2028-06-07T00:00:00.000Z") → "2028-06-07"
  if (date.includes("T")) {
    return date.split("T")[0] ?? date;
  }
  return date;
}

export function isFuturePreorder({
  publicationDate,
  statusMessage,
}: {
  publicationDate?: string | null;
  statusMessage?: string | null;
}): boolean {
  const rawDate =
    publicationDate ?? getDateFromStatusMessage(statusMessage ?? undefined);
  if (!rawDate) return false;

  const stockDateInfo = getStockDateInfo(normalizeToDateString(rawDate));
  return stockDateInfo.hasDate && !stockDateInfo.isPastOrToday;
}

export function isLongHorizonPreorder({
  publicationDate,
  statusMessage,
}: {
  publicationDate?: string | null;
  statusMessage?: string | null;
}): boolean {
  const rawDate =
    publicationDate ?? getDateFromStatusMessage(statusMessage ?? undefined);
  if (!rawDate) return false;

  const dateToCheck = normalizeToDateString(rawDate);
  const stockDateInfo = getStockDateInfo(dateToCheck);
  if (!stockDateInfo.hasDate) return false;

  return !stockDateInfo.isPastOrToday && !stockDateInfo.isWithinNext30;
}
